import { FunctionComponent, HTMLProps } from 'react';
import styled from 'styled-components';

export interface InputLabelProps extends HTMLProps<HTMLLabelElement> {
  label: string;
  labelSpacing?: string;
  required?: boolean;
}

const InputLabel: FunctionComponent<InputLabelProps> = ({
  label,
  labelSpacing = '4px',
  required = false,
}) => {
  return (
    <InputLabelStyled labelSpacing={labelSpacing}>
      {label}
      {required && <InputLabelRequired>*</InputLabelRequired>}
    </InputLabelStyled>
  );
};

export default InputLabel;

export const InputLabelStyled = styled.label<{ labelSpacing: string }>`
  display: inline-block;

  ${({ theme, labelSpacing }) => `
    ${theme.typography.UI14SB};
    color: ${theme.color.gray700};
    margin-bottom: ${labelSpacing};
    `};
`;

export const InputLabelRequired = styled.span`
  color: ${({ theme }) => theme.color.red500};
`;
